import { apiClient } from '@shared/api/client'
import type {
  PaymentConfirmRequest,
  PaymentConfirmResponse,
  PaymentHistoryItem,
  PaymentPrepareRequest,
  PaymentPrepareResponse,
} from '../model/types'

export const paymentApi = {
  /** 결제 준비 — orderId 발급 */
  prepare: (body: PaymentPrepareRequest) =>
    apiClient
      .post<PaymentPrepareResponse>('/v1/front/payments/prepare', body)
      .then((res) => res.data),

  /** 결제 승인 */
  confirm: (body: PaymentConfirmRequest) =>
    apiClient
      .post<PaymentConfirmResponse>('/v1/front/payments/confirm', body)
      .then((res) => res.data),

  /** 결제 내역 목록 */
  history: () =>
    apiClient.get<PaymentHistoryItem[]>('/v1/front/payments/history').then((res) => res.data),

  /** 결제 상세 조회 */
  getByOrderId: (orderId: string) =>
    apiClient.get<PaymentHistoryItem>(`/v1/front/payments/${orderId}`).then((res) => res.data),
}
